import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { ShipOrderData } from '../apis/shipOrder.api'
import Card from '../components/Card'
import PageHeading from '../components/PageHeading'
import TableVertical, { TableVerticalHeader } from '../components/TableVertical'
import CardButton from '../components/CardButton'

interface ShipOrderTableProps {
  shipOrder: ShipOrderData | null
  onEditClick: () => void
}

export default class ShipOrderTable extends Component<ShipOrderTableProps> {
  headers: TableVerticalHeader[] = [
    { heading: i18n('Ship code'), path: 'code' },
    { heading: i18n('Freight number'), path: 'freightNumber' },
    { heading: i18n('Ship datetime'), path: 'shipAt', date: true, tooltip: 'createdUser.username' },
    { heading: i18n('Delivery date'), path: 'deliveryAt', date: true },
    { heading: i18n('Note'), path: 'note' },
    { heading: i18n('Customer name'), path: 'customerSite.contact.customer.name' },
    { heading: i18n('Purchase order'), path: 'purchaseOrder' },
    { heading: i18n('Sales order'), path: 'salesOrder' },
    { heading: i18n('Address'), path: 'customerSite.address.address' },
    { heading: i18n('City'), path: 'customerSite.address.city' },
    { heading: i18n('State'), path: 'customerSite.address.state' },
    { heading: i18n('Zip'), path: 'customerSite.address.zip' },
    { heading: i18n("Created at"),
      path: 'createdAt',
      date: true,
      tooltip: 'createdUser.username'
    },
    { heading: i18n("Updated at"),
      path: 'updatedAt',
      date: true,
      tooltip: 'updatedUser.username'
    }
  ]

  get table () {
    const { shipOrder } = this.props
    return shipOrder &&
      <TableVertical
        headers={this.headers}
        data={shipOrder} />
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("View Ship Order")}
          doc='ship-orders-view-ship-order' />
        {this.table}
        <CardButton
          proceedText={i18n("Edit")}
          cancelText={i18n("Back")}
          onProceedClick={this.props.onEditClick} />
      </Card>
    )
  }
}
